<div class="app-loading master-page">
    <div class="logo"></div>
    <svg class="spinner" viewBox="25 25 50 50">
        <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
    </svg>
</div>

<div class="new-features">
    <span (click)="newFeaturesOpenModal()">{{ 'geral.novidades.titulo.parte-1' | translate }} <span class="underline">{{ 'geral.novidades.titulo.parte-2' | translate }}</span> {{ 'geral.novidades.titulo.parte-3' | translate }}</span>
    <div class="new-features-fechar" (click)="newFeaturesClose()"><i class="fa fa-times"></i></div>
</div>

@if (needsCookieConsent) {
    <div class="cookies-management">
        <div class="backdrop" [ngClass]="{ 'modal-open': cookiesManagementModal != undefined ? cookiesManagementModal.isOpen : false }"></div>
        <div class="content-wrapper">
            <div class="content">
                <div class="text">
                    <p>{{ 'geral.cookie-management.page-footer.text-info' | translate }}</p>
                    <p>{{ 'geral.cookie-management.page-footer.text-action' | translate }} <span class="cookie-policy" (click)="openCookiePolicy()">{{ 'geral.cookie-management.page-footer.text-url' | translate }}</span></p>
                </div>
                <div class="buttons">
                    <span (click)="cookiesManagementModal.open()">{{ 'geral.cookie-management.page-footer.button.manage-cookies' | translate }}</span>
                    <button customButton type="submit" [styleType]="'secondary'" [isLoading]="loadAcceptAllCookies" label="geral.cookie-management.page-footer.button.accept-all" (click)="acceptAllCookies()"></button>
                </div>
            </div>
        </div>
    </div>
}

<app-image-display></app-image-display>

<nav role="navigation" class="navbar topnavbar navbar-expand-md" [ngClass]="accountService.checkIfNotInIframe() ? '' : 'd-none'">
    <div class="navbar-header">
        <a [routerLink]="'/'" class="navbar-brand nav-link">
            <div class="brand-logo maior-1024">
                <img src="assets/imagens/partsfy/logo-white.png" alt="Partsfy" class="block-center rounded" />
            </div>
            <div class="brand-logo menor-1024">
                <img src="assets/imagens/partsfy/logo-white.png" alt="Partsfy" class="block-center rounded" />
            </div>
        </a>
    </div>
    <div class="nav-wrapper">
        <ul class="nav navbar-nav">
            @for (tela of userService.user()?.pages | filterBy: pageIsMenuSuperiorFilter; track tela) {
                <li class="nav-item dropdown" [ngClass]="{ 'dropdown': tela.subPages?.length > 0 }">
                    @if (tela.subPages?.length <= 0) {
                        <a routerLinkActive="ativo" class="name nav-link" [routerLink]="'/' + tela.url">
                            <span routerLinkActive="ativo">{{ obterNomeTela(tela.url) | translate}}</span>
                        </a>
                    } @else {
                        <a class="name dropdown-toggle nav-link" href="javascript:void(0)" role="button" data-bs-toggle="dropdown" data-hover="dropdown" data-close-others="true" aria-expanded="false">{{ obterNomeSubTela(tela.url, null) | translate}}</a>
                        <ul class="dropdown-menu dropdown-menu-end menuuser">
                            @for (subtela of tela.subPages; track subtela) {
                                <li>
                                    <a class="dropdown-item" [routerLink]="'/' + tela.url + '/' + subtela">{{obterNomeSubTela(tela.url, subtela) | translate}}</a>
                                </li>
                            }
                        </ul>
                    }
                </li>
            }
        </ul>
        @if (userService.user()?.dadosMultiUsuario?.length > 0) {
            <ul class="nav navbar-nav" [ngClass]="{ 'd-none': this.generalService.hideMultiloginDropDown() }">
                <li class="nav-item">
                    <div class="divMultiUser nav-link">
                        <span class="input-group-text multilogin-icon"><i-feather name="users"></i-feather></span>
                        <select class="form-select form-select-sm multi-usuario">
                            @for (dados of userService.user().dadosMultiUsuario; track dados) {
                                <option [attr.selected]="dados.id === userService.userId() ? 'selected' : null" value="{{dados.id}}">
                                    {{dados.current_company_name}} ({{dados.current_name}})
                                </option>
                            }
                        </select>
                    </div>
                </li>
            </ul>
        }
        @if (userService.user()) {
            <ul class="nav navbar-nav ml-auto nav-invest menu-direita menor-1024">
                @if (showCashback()) {
                    <li class="nav-item dropdown">
                        <a href="javascript:void(0)" (click)="abrirCashback()" class="chat name menu-cashback nav-link">
                            <div><span>{{userService.user().cashback.availableCashback | currency:'R$'}}</span></div>
                        </a>
                    </li>
                }
                @if (showNotification()) {
                    <li class="nav-item dropdown">
                        <a href="javascript:void(0)" class="bell dropdown-toggle col-md-12 chat name nav-link" role="button" style="margin-top: 2px;" [attr.data-bs-toggle]="notificationListUnreadMessages  > 0 ? 'dropdown' : null" data-close-others="true" aria-expanded="false" [attr.disabled]="(notificationListUnreadMessages <= 0) ? 'disabled' : null">
                            <i-feather name="bell" [ngClass]="{ 'with-notifications': notificationListUnreadMessages > 0 }"></i-feather>
                            @if (notificationListUnreadMessages > 0) {
                                <div class="badge label-danger">{{notificationListUnreadMessages > 9 ? "9+" : notificationListUnreadMessages}}</div>
                            }
                        </a>
                        @if (notificationListUnreadMessages > 0) {
                            <ul class="dropdown-menu dropdown-menu-end">
                                <div class="menuuser list-group list-group-hover list-group-striped">
                                    @for (notificacao of currentNotificationList; track notificacao) {
                                        <li>
                                            <a class="dropdown-item" data-toggle="modal" (click)="partsfyNotificationService.abrirNotificacoes(notificacao)">
                                                @if (this.userService.userIsCentral()) {
                                                    <span>{{notificacao?.repairer_name}} - #{{notificacao?.order_id}} - {{ 'geral.notificacao.peca-cancelada.titulo' | translate }}</span>
                                                } @else {
                                                    <span>#{{notificacao?.order_id}} - {{ 'geral.notificacao.peca-cancelada.titulo' | translate }}</span>
                                                }
                                            </a>
                                        </li>
                                    }
                                </div>
                            </ul>
                        }
                    </li>
                }
                @if (userService.user() && !userService.user().isAdmin) {
                    <li class="dropdown nav-item" style="white-space: nowrap;">
                        <a href="javascript:void(0)" (click)="crispAbrir()" class="chat name help nav-link">
                            <i class="fa fa-comments" aria-hidden="true" title="{{ 'elemento.topbar.atendimento.title' | translate }}"></i>
                            <span>{{ 'elemento.topbar.atendimento.label' | translate }}</span>
                        </a>
                    </li>
                }
                <li class="dropdown dropdown-user maior-1024 nav-item">
                    <a class="nav-link" href="javascript:void(0)" role="button" data-bs-toggle="dropdown" data-hover="dropdown" data-close-others="true" aria-expanded="false">
                        <div class="iconUser">
                            <i-feather name="user"></i-feather>
                        </div>
                        <span>{{userService.user()?.firstName}}</span>
                        <i-feather class="chevron-down-user" name="chevron-down"></i-feather>
                    </a>
                    <ul class="dropdown-menu dropdown-menu-end menuuser">
                        @for (tela of userMenu(); track tela) {
                            <li>
                                <a class="dropdown-item" [routerLink]="'/' + tela.url">
                                    <i class="fa" [ngClass]="tela.icon"></i> {{ obterNomeTela(tela.url) | translate}}
                                </a>
                            </li>
                        }
                        <li>
                            <a class="dropdown-item" routerLink="/alterar-senha">
                                <i class="fa fa-key"></i> {{ 'geral.menu.alterar-senha' | translate}}
                            </a>
                        </li>
                        @if (!userService.userIsSupport()) {
                            <li>
                                <a class="dropdown-item" href="javascript:void(0)" (click)="newFeaturesOpenModal()">
                                    <i class="fa fa-newspaper-o"></i> {{ 'geral.menu.novidades' | translate}}
                                </a>
                            </li>
                        }
                        <li>
                            <a class="dropdown-item" href="javascript:void(0)" (click)="efetuarLogout()">
                                <i class="fa fa-sign-out"></i> {{ 'geral.menu.sair' | translate}}
                            </a>
                        </li>
                    </ul>
                </li>
                @if (userService.user() && !userService.user().isAdmin) {
                    <li class="dropdown dropdown-ajuda menor-1024" style="white-space: nowrap;">
                        <a href="javascript:void(0)" (click)="crispAbrir()" class="chat name help">
                            <i class="fa fa-comments" aria-hidden="true" title="{{ 'elemento.topbar.atendimento.title' | translate }}"></i>
                            <span>{{ 'elemento.topbar.atendimento.label-small' | translate }}</span>
                        </a>
                    </li>
                }
                <li class="dropdown dropdown-user menor-1024">
                    <a href="javascript:void(0)" (click)="efetuarLogout()">
                        <i class="fa fa-sign-out"></i> {{ 'geral.menu.sair' | translate}}
                    </a>
                </li>
            </ul>
        }
    </div>
</nav>

<div class="partsfy-content-container">
    <div class="partsfy-content">
        <div>
            <section class="mainView">
                <router-outlet (activate)="changeOfRoutes()"></router-outlet>
            </section>
        </div>

        @if (showNotification()) {
            <div>
                <app-pecas-canceladas></app-pecas-canceladas>
            </div>
        }
    </div>
</div>

<ng-template #templateNovidades>
    <div class="modal-header">
        <h4 class="modal-title">{{ 'geral.novidades.modal.titulo' | translate }}</h4>
        <button type="button" data-dismiss="modal" aria-label="Close" class="btn-close" (click)="newFeaturesCloseModal();"></button>
    </div>
    <div class="modal-body">
        @if (newFeatures.length > 0) {
            <ng-scrollbar>
                @for (update of newFeatures; track update) {
                    <div class="update">
                        <h2 class="title">({{update.release_date | date:'longDate' }}) - <span>{{update.title}}</span></h2>
                        <div class="content">
                            @if (update.features_info_display) {
                                <h3 class="content-title">{{ 'geral.novidades.modal.funcionalidades' | translate }}</h3>
                                <div class="features" [innerHTML]="update.features_info_display"></div>
                            }
                            @if (update.bugs_info_display) {
                                <h3 class="content-title">{{ 'geral.novidades.modal.correcoes' | translate }}</h3>
                                <div class="bugs" [innerHTML]="update.bugs_info_display"></div>
                            }
                        </div>
                    </div>
                }
                <div class="button-container">
                    @if (newFeatures.length < totalNewFeatures) {
                        <button (click)="loadMoreNewFeatures()" class="btn btn-primary">{{ 'geral.novidades.modal.ver-mais' | translate }}</button>
                    }
                </div>
            </ng-scrollbar>
        } @else {
            <ng-scrollbar>
                <div class="vazio">
                    {{ 'support.manutencao.cadastro-novidades.listagem.vazio' | translate}}
                </div>
            </ng-scrollbar>
        }
    </div>
    <ngx-ui-loader [loaderId]="'loader-new-features'"></ngx-ui-loader>
</ng-template>

<app-user-validation-modal #templateUserValidationModal ></app-user-validation-modal>
<app-cookies-management-modal #templateCookiesManagementModal (acceptCookies)="acceptCookies($event)"></app-cookies-management-modal>

